/* =====================================================
   MORE COLORS – ARROW CONTROL (SAFE)
===================================================== */
(function () {
  function update(block) {
    const viewport = block.querySelector('.mc-viewport');
    const prev = block.querySelector('.mc-prev');
    const next = block.querySelector('.mc-next');
    const items = block.querySelectorAll('.mc-item');
    if (!viewport || !prev || !next) return;

    const max = viewport.scrollWidth - viewport.clientWidth;
    const isDesktop = window.innerWidth >= 768;
    const isMobile = window.innerWidth < 768;

    if ((isDesktop && items.length > 4) || (isMobile && items.length > 2)) {
      block.classList.add('has-arrows');
    } else {
      block.classList.remove('has-arrows');
    }

    prev.disabled = viewport.scrollLeft <= 0;
    next.disabled = viewport.scrollLeft >= max - 1;
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.mc-arrow');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    const block = btn.closest('.mc-block');
    const viewport = block.querySelector('.mc-viewport');
    const item = block.querySelector('.mc-item');
    if (!viewport || !item) return;

    const amount = item.offsetWidth + 10;
    viewport.scrollBy({
      left: btn.classList.contains('mc-prev') ? -amount : amount,
      behavior: 'smooth'
    });
    setTimeout(() => update(block), 250);
  });

  document.addEventListener('scroll', function (e) {
    const vp = e.target.closest && e.target.closest('.mc-viewport');
    if (!vp) return;
    const block = vp.closest('.mc-block');
    if (block) update(block);
  }, true);

  window.addEventListener('resize', function () {
    document.querySelectorAll('.mc-block').forEach(update);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.mc-block').forEach(update);
  });
})();

/* =====================================================
   COLLECTION FILTER UX – v2.5.1
   - ultra-minimal dual price slider
   - one AJAX path only (blocks native form-submit race)
   - keeps grid height stable while results are replaced
   - keeps sidebar scroll position stable
   - removes collection entrance/loading flashes
===================================================== */
(function () {
  var smoothState = null;
  var smoothObserver = null;
  var smoothFallback = null;

  function ensureStyles() {
    if (document.getElementById('dk-filter-ux-styles')) return;

    var style = document.createElement('style');
    style.id = 'dk-filter-ux-styles';
    style.textContent = [
      '.dk-price-slider{padding:4px 2px 2px;margin-top:2px;}',
      '.dk-price-rail{position:relative;height:22px;margin:0 6px;}',
      '.dk-price-track{position:absolute;left:0;right:0;top:10px;height:2px;border-radius:999px;background:#dfe3e6;overflow:hidden;}',
      '.dk-price-fill{position:absolute;top:0;bottom:0;border-radius:999px;background:#394557;}',
      '.dk-price-range{position:absolute;left:0;top:0;width:100%;height:22px;margin:0;padding:0;background:transparent;appearance:none;-webkit-appearance:none;pointer-events:none;outline:none;}',
      '.dk-price-range::-webkit-slider-runnable-track{height:2px;background:transparent;border:0;}',
      '.dk-price-range::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:12px;height:12px;margin-top:-5px;border:0;border-radius:50%;background:#394557;box-shadow:none;pointer-events:auto;cursor:pointer;}',
      '.dk-price-range::-moz-range-track{height:2px;background:transparent;border:0;}',
      '.dk-price-range::-moz-range-progress{background:transparent;}',
      '.dk-price-range::-moz-range-thumb{width:12px;height:12px;border:0;border-radius:50%;background:#394557;box-shadow:none;pointer-events:auto;cursor:pointer;}',
      '.dk-price-range:focus-visible::-webkit-slider-thumb{outline:2px solid rgba(57,69,87,.22);outline-offset:3px;}',
      '.dk-price-range:focus-visible::-moz-range-thumb{outline:2px solid rgba(57,69,87,.22);outline-offset:3px;}',
      '.dk-price-values{display:flex;align-items:center;justify-content:space-between;gap:10px;font-size:13px;line-height:1.25;margin:2px 1px 0;color:inherit;}',
      '.dk-price-values span{font-weight:400;white-space:nowrap;}',
      '@media(max-width:768px){.dk-price-rail{height:26px}.dk-price-track{top:12px}.dk-price-range{height:26px}.dk-price-range::-webkit-slider-thumb{width:16px;height:16px;margin-top:-7px}.dk-price-range::-moz-range-thumb{width:16px;height:16px}}',

      'body.template-collection.loading .loadingBox,body.template-collection.loading .modalOverly{display:none!important;visibility:hidden!important;opacity:0!important;}',
      'body.template-collection.loading .main-col .grid-view-item{opacity:1!important;}',
      'body.template-collection.dk-filter-smoothing .productList,body.template-collection.dk-filter-smoothing .sidebar_tags{overflow-anchor:none;}',
      '.template-collection .productList .grid-view-item.wow,.template-collection .productList .list-view-item.wow{visibility:visible!important;opacity:1!important;transform:none!important;animation:none!important;animation-delay:0s!important;transition:none!important;}',
      '.template-collection .productList .grid-view-item.fadeIn,.template-collection .productList .list-view-item.fadeInUp{visibility:visible!important;opacity:1!important;transform:none!important;animation:none!important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function formatPrice(value) {
    var currency = 'INR';
    if (window.Shopify && Shopify.currency && Shopify.currency.active) currency = Shopify.currency.active;

    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0
      }).format(Number(value));
    } catch (e) {
      return '₹' + Number(value).toLocaleString('en-IN', { maximumFractionDigits: 0 });
    }
  }

  function initPriceSlider(priceBox) {
    if (!priceBox) return;

    var source = priceBox.querySelector('price-range');
    if (!source || source.getAttribute('data-dk-slider-ready') === 'true') return;

    var inputs = source.querySelectorAll('input[type="number"]');
    if (inputs.length < 2) return;

    var minInput = inputs[0];
    var maxInput = inputs[1];
    var rangeMax = parseFloat(maxInput.max || minInput.max || maxInput.placeholder || '0');
    if (!isFinite(rangeMax) || rangeMax <= 0) return;

    var minValue = String(minInput.value || '').trim() === '' ? 0 : parseFloat(minInput.value);
    var maxValue = String(maxInput.value || '').trim() === '' ? rangeMax : parseFloat(maxInput.value);
    if (!isFinite(minValue)) minValue = 0;
    if (!isFinite(maxValue)) maxValue = rangeMax;

    minValue = Math.max(0, Math.min(minValue, rangeMax));
    maxValue = Math.max(0, Math.min(maxValue, rangeMax));
    if (minValue > maxValue) minValue = maxValue;

    source.setAttribute('data-dk-slider-ready', 'true');
    source.style.setProperty('display', 'none', 'important');
    minInput.classList.add('dk-price-source-input');
    maxInput.classList.add('dk-price-source-input');

    var slider = document.createElement('div');
    slider.className = 'dk-price-slider';
    slider.innerHTML =
      '<div class="dk-price-rail">' +
        '<div class="dk-price-track"><div class="dk-price-fill"></div></div>' +
        '<input class="dk-price-range dk-price-min" type="range" min="0" max="' + rangeMax + '" step="1" value="' + minValue + '" aria-label="Minimum price">' +
        '<input class="dk-price-range dk-price-max" type="range" min="0" max="' + rangeMax + '" step="1" value="' + maxValue + '" aria-label="Maximum price">' +
      '</div>' +
      '<div class="dk-price-values">' +
        '<span class="dk-price-min-label"></span>' +
        '<span class="dk-price-max-label"></span>' +
      '</div>';

    source.insertAdjacentElement('afterend', slider);

    var minRange = slider.querySelector('.dk-price-min');
    var maxRange = slider.querySelector('.dk-price-max');
    var minLabel = slider.querySelector('.dk-price-min-label');
    var maxLabel = slider.querySelector('.dk-price-max-label');
    var fill = slider.querySelector('.dk-price-fill');

    function sync(changedRange) {
      var currentMin = parseFloat(minRange.value);
      var currentMax = parseFloat(maxRange.value);

      if (currentMin > currentMax) {
        if (changedRange === minRange) {
          currentMin = currentMax;
          minRange.value = String(currentMin);
        } else {
          currentMax = currentMin;
          maxRange.value = String(currentMax);
        }
      }

      minInput.value = currentMin <= 0 ? '' : String(Math.round(currentMin));
      maxInput.value = currentMax >= rangeMax ? '' : String(Math.round(currentMax));
      minLabel.textContent = formatPrice(currentMin);
      maxLabel.textContent = formatPrice(currentMax);

      var minPercent = (currentMin / rangeMax) * 100;
      var maxPercent = (currentMax / rangeMax) * 100;
      fill.style.left = minPercent + '%';
      fill.style.right = (100 - maxPercent) + '%';
      minRange.style.zIndex = currentMin > rangeMax * 0.8 ? '5' : '3';
      maxRange.style.zIndex = '4';
    }

    function submitPrice(range) {
      sync(range);
      var sourceInput = range === minRange ? minInput : maxInput;
      sourceInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    minRange.addEventListener('input', function () { sync(minRange); });
    maxRange.addEventListener('input', function () { sync(maxRange); });
    minRange.addEventListener('change', function () { submitPrice(minRange); });
    maxRange.addEventListener('change', function () { submitPrice(maxRange); });
    sync();
  }

  function initPriceSliders() {
    ensureStyles();
    document.querySelectorAll('.sidebar_tags .flPrice').forEach(initPriceSlider);
  }

  function removeLoadingVisuals() {
    document.body.classList.remove('loading', 'hideOverly');
  }

  function finishSmoothRefresh() {
    if (!smoothState) return;

    clearTimeout(smoothFallback);
    if (smoothObserver) {
      smoothObserver.disconnect();
      smoothObserver = null;
    }

    var currentSidebar = document.querySelector('.sidebar_tags');
    if (currentSidebar) currentSidebar.scrollTop = smoothState.sidebarScrollTop;

    var grid = smoothState.grid;
    removeLoadingVisuals();

    requestAnimationFrame(function () {
      if (grid) grid.style.minHeight = '';
      document.body.classList.remove('dk-filter-smoothing');
      smoothState = null;
    });
  }

  function prepareSmoothRefresh() {
    ensureStyles();

    if (smoothObserver) smoothObserver.disconnect();
    clearTimeout(smoothFallback);

    var grid = document.querySelector('.productList .grid-products, .productList .list-view-items');
    var sidebar = document.querySelector('.sidebar_tags');

    smoothState = {
      grid: grid,
      sidebarScrollTop: sidebar ? sidebar.scrollTop : 0
    };

    document.body.classList.add('dk-filter-smoothing');

    if (grid) {
      var height = Math.ceil(grid.getBoundingClientRect().height || 0);
      if (height > 0) grid.style.minHeight = height + 'px';

      smoothObserver = new MutationObserver(function () {
        requestAnimationFrame(function () {
          requestAnimationFrame(finishSmoothRefresh);
        });
      });
      smoothObserver.observe(grid, { childList: true });
    }

    smoothFallback = setTimeout(finishSmoothRefresh, 2200);
  }

  function patchAjaxFilter() {
    if (typeof window.ajaxfilter !== 'function') return false;
    if (window.ajaxfilter.__dkSmoothPatched) return true;

    var originalAjaxFilter = window.ajaxfilter;
    var smoothAjaxFilter = function (url) {
      prepareSmoothRefresh();
      var result = originalAjaxFilter(url);

      /* Avone adds the generic body loading state synchronously in beforeSend.
         Remove it immediately for collection filtering; the request still runs normally. */
      removeLoadingVisuals();
      requestAnimationFrame(removeLoadingVisuals);
      return result;
    };

    smoothAjaxFilter.__dkSmoothPatched = true;
    smoothAjaxFilter.__dkOriginal = originalAjaxFilter;
    window.ajaxfilter = smoothAjaxFilter;
    return true;
  }

  function installAjaxPatch(attempt) {
    if (patchAjaxFilter()) return;
    if (attempt < 40) setTimeout(function () { installAjaxPatch(attempt + 1); }, 50);
  }

  function buildSidebarFilterUrl(form) {
    var params = new URLSearchParams();
    var formData = new FormData(form);

    formData.forEach(function (value, key) {
      var stringValue = String(value);
      if (stringValue !== '') params.append(key, stringValue);
    });

    var base = form.getAttribute('action') || window.location.pathname;
    if (base.indexOf('http://') !== 0 && base.indexOf('https://') !== 0) {
      if (base.charAt(0) !== '/') base = '/' + base;
      base = window.location.origin + base;
    }

    return base.split('?')[0] + (params.toString() ? '?' + params.toString() : '');
  }

  /* Capture before Avone's delegated change listener and before the inline
     this.form.submit() handlers in the old sidebar markup. This prevents the
     AJAX + full-page-submit race that caused the visible page jerk. */
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches) return;

    if (!target.matches('.sidebar_tags .flForm .custCheck, .sidebar_tags .flForm .prRange, .sidebar_tags .flForm #SortBy')) return;

    var form = target.closest('form');
    if (!form) return;

    installAjaxPatch(0);
    if (typeof window.ajaxfilter !== 'function') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    window.ajaxfilter(buildSidebarFilterUrl(form));
  }, true);

  /* =====================================================
     FILTER ACCORDION STATE
     Only groups with an active value remain open.
     Clear All leaves every group closed.
  ===================================================== */
  function groupHasActiveValue(content) {
    if (!content) return false;

    if (content.querySelector('input[type="checkbox"]:checked, input[type="radio"]:checked')) return true;

    var priceInputs = content.querySelectorAll('.dk-price-source-input, input[type="number"]');
    for (var i = 0; i < priceInputs.length; i++) {
      if (String(priceInputs[i].value || '').trim() !== '') return true;
    }

    return false;
  }

  function applyFilterAccordionState() {
    initPriceSliders();

    var headers = document.querySelectorAll('.sidebar_tags [data-key], .sidebar_tags .flPrice > .widget-title');
    headers.forEach(function (header) {
      var content = header.nextElementSibling;
      var icon = header.querySelector('svg');
      if (!content) return;

      var shouldOpen = groupHasActiveValue(content);
      content.style.display = shouldOpen ? 'block' : 'none';
      if (icon) icon.style.transform = shouldOpen ? 'rotate(180deg)' : 'rotate(0deg)';
    });
  }

  window.restoreFiltersState = applyFilterAccordionState;

  function start() {
    ensureStyles();
    window.restoreFiltersState = applyFilterAccordionState;
    applyFilterAccordionState();
    installAjaxPatch(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('popstate', function () {
    setTimeout(applyFilterAccordionState, 0);
  });
})();
